import { Box } from '@chakra-ui/react';
import { Grid } from '@time-line/components/common';
import type { ProductReviewsInnerProps } from 'components/reviews/ProductReviewsInner';
import { ProductReviewsInner } from 'components/reviews/ProductReviewsInner';

export function ProductReviewsBlock(props: ProductReviewsInnerProps) {
  return (
    <Grid className="section--product-reviews" my="2xl">
      <Grid.Inner gridColumn="main">
        <Box gridColumn="span 12">
          <ProductReviewsInner overline="Customer reviews" {...props} />
        </Box>
      </Grid.Inner>
    </Grid>
  );
}
